import { TagStruct } from "src/app/shared/components/tag/tag.struct";
import { PrescriptionSolutionMedicine } from "../../models/pharmacy/prescription-solution-medicine.model";

export class PrescriptionSolutionMedicineStruct {
    public prescriptionSolutionMedicine: PrescriptionSolutionMedicine = new PrescriptionSolutionMedicine();
    
    public medicineName: string;
    public doseToAdministeredName: string;

    public idLocation?: number;
    public quantityReleased: number;
    public calculatedDispensationQuantity: number;
    public idPresentationType: number;
    public amountRemaining?: number;

    public patientHasAllergy: boolean;
    public isBeforeActualSchedulingCycle: boolean;
    public listTags: TagStruct[] = [];
    tagsTooltipText: string;
}